import React, { Context } from 'react';

import { AuthContextData } from '../types/internal';

export const AuthContext: Context<AuthContextData> = React.createContext<AuthContextData>([
  { token: null, userData: null, appSettings: null, isAuthInitialized: false }, (): void => undefined,
]);
